var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 30,
    viewBox: "0 0 258 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8962 16.7347C27.2089 23.552 31.1992 29.8597 38.773 29.8597C47.1092 30.1138 119.064 29.9656 129 29.8597C138.936 29.9656 210.891 30.1138 219.227 29.8597C226.801 29.8597 230.791 23.552 235.104 16.7347C240.174 8.71951 245.69 0 258 0H129H0C12.3095 0 17.8256 8.71951 22.8962 16.7347Z",
    fill: "#ED967B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionBg);
export default __webpack_public_path__ + "static/media/Union-bg.a7a274983b41752deba257c09b459e21.svg";
export { ForwardRef as ReactComponent };